import React, {memo} from 'react'
import PropTypes from 'prop-types'
import ScrollableAnchor from 'react-scrollable-anchor'
import Swiper from 'react-id-swiper'

import lazyazImage from '../assets/images/projects/lazyaz.jpg'
import lazyazImage2x from '../assets/images/projects/lazyaz@2x.jpg'
import wolfFoxImage from '../assets/images/projects/wolf-fox.jpg'
import wolfFoxImage2x from '../assets/images/projects/wolf-fox@2x.jpg'
import strongherImage from '../assets/images/projects/strongher.jpg'
import strongherImage2x from '../assets/images/projects/strongher@2x.jpg'
import queryTrucksImage from '../assets/images/projects/query-trucks.jpg'
import queryTrucksImage2x from '../assets/images/projects/query-trucks@2x.jpg'
import goodnestImage from '../assets/images/projects/goodnest.jpg'
import goodnestImage2x from '../assets/images/projects/goodnest@2x.jpg'
import starshipImage from '../assets/images/projects/starship.jpg'
import starshipImage2x from '../assets/images/projects/starship@2x.jpg'
import foodprintImage from '../assets/images/projects/foodprint.jpg'
import foodprintImage2x from '../assets/images/projects/foodprint@2x.jpg'
import rogueImage from '../assets/images/projects/rogue.jpg'
import rogueImage2x from '../assets/images/projects/rogue@2x.jpg'
import sharedSpaceImage from '../assets/images/projects/shared-space.jpg'
import sharedSpaceImage2x from '../assets/images/projects/shared-space@2x.jpg'
import twelveSaffronImage from '../assets/images/projects/twelveSaffron.jpg'
import twelveSaffronImage2x from '../assets/images/projects/twelveSaffron@2x.jpg'
import ScrollAnimation from './ScrollAnimation'
import {renderBullet} from '../utils/helpers'
import './Portfolio.scss'

const projects = [
  {
    id: 1,
    title: 'LazyAz',
    image: lazyazImage,
    image2x: lazyazImage2x,
    href: 'https://7glyphs.com/portfolio/projects/lazyaz',
  },
  {
    id: 2,
    title: 'Wolf & Fox',
    image: wolfFoxImage,
    image2x: wolfFoxImage2x,
    href: 'https://wolfandfox.co.nz',
  },
  {
    id: 3,
    title: 'StrongHer',
    image: strongherImage,
    image2x: strongherImage2x,
    href: 'https://strongherapp.com',
  },
  {
    id: 4,
    title: 'Query Trucks',
    image: queryTrucksImage,
    image2x: queryTrucksImage2x,
    href: 'https://7glyphs.com/portfolio/projects/quarry-trucks',
  },
  {
    id: 5,
    title: 'Goodnest',
    image: goodnestImage,
    image2x: goodnestImage2x,
    href: 'https://7glyphs.com/portfolio/projects/goodnest-booking-process',
  },
  {
    id: 6,
    title: 'Starship',
    image: starshipImage,
    image2x: starshipImage2x,
    href: 'https://7glyphs.com/portfolio/projects/starshipit',
  },
  {
    id: 7,
    title: 'Foodprint',
    image: foodprintImage,
    image2x: foodprintImage2x,
    href: 'https://foodprint.app',
  },
  {
    id: 8,
    title: 'Rogue Travel',
    image: rogueImage,
    image2x: rogueImage2x,
    href: 'https://7glyphs.com/portfolio/projects/rogue-travel',
  },
  {
    id: 9,
    title: 'Shared Space',
    image: sharedSpaceImage,
    image2x: sharedSpaceImage2x,
    href: 'https://7glyphs.com/portfolio/projects/shared-space',
  },
  {
    id: 10,
    title: '12 Saffron Street',
    image: twelveSaffronImage,
    image2x: twelveSaffronImage2x,
    href: 'https://12saffron.co.nz',
  },
]

const settings = {
  loop: true,
  grabCursor: true,
  speed: 2000,
  slidesPerView: 4,
  spaceBetween: 12,
  centeredSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  breakpoints: {
    960: {
      slidesPerView: 2,
    },
    1280: {
      slidesPerView: 4,
      spaceBetween: 8,
    },
  },
}

const secondSettings = {
  ...settings,
  autoplay: {
    reverseDirection: true,
    delay: 3000,
    disableOnInteraction: false,
  },
}

const mobileSettings = {
  loop: true,
  grabCursor: true,
  preventClicksPropagation: false,
  centeredSlides: true,
  speed: 1000,
  slidesPerView: 1,
  spaceBetween: -64,
  pagination: {
    renderBullet,
    el: '.Bullets',
    clickable: true,
  },
}

const renderProjects = projects =>
  projects.map(project => (
    <div key={project.id}>
      <a className="Portfolio-Link" href={project.href} tabIndex={-1} target="_blank" rel="noopener noreferrer">
        <div className="Portfolio-Overlay">
          <h3 className="Portfolio-OverlayTitle">{project.title}</h3>
        </div>
        <img
          className="Portfolio-Image"
          width={327}
          src={project.image}
          srcSet={`${project.image2x} 2x`}
          alt={project.title}
        />
      </a>
    </div>
  ))

Portfolio.propTypes = {
  width: PropTypes.string.isRequired,
}

function Portfolio({width}) {
  return (
    <ScrollableAnchor id="portfolio">
      <section className="Portfolio">
        <ScrollAnimation tag="h2" className="Portfolio-Title Title" effect="fadeInTop">
          Portfolio
        </ScrollAnimation>
        {width === 'xs' ? (
          <Swiper {...mobileSettings}>{renderProjects(projects)}</Swiper>
        ) : (
          <>
            <Swiper {...settings}>{renderProjects(projects.slice(0, 5))}</Swiper>
            <Swiper {...secondSettings}>{renderProjects(projects.slice(5))}</Swiper>
          </>
        )}
      </section>
    </ScrollableAnchor>
  )
}

export default memo(Portfolio)
